/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/jquery/aacom/plugins/aaPlaceHolder.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/legacy/plugins/aa-place-holder.js
**/

/*
 * aaPlaceHolder.js
 * jQuery Plugin to add inline-label behavior to forms
*/
(function($) {
	$.fn.aaPlaceHolder = function (params) {
		
		//	Set variables and properties for use inside the plugin
		var self = this,
			//	Set default property values
			defaults = {
				labelSelector: "label",			//	Filter to target labels
				classLabelInline: "inline",		//	Class to add to labels to desginate them as inline
				classLabelNormal: "inactive",	//	Class to apply to inactive labels
				classLabelSelected: "active"	//	Class to apply when the input is active
			},
			
			settings = $.extend({}, defaults, params),	//	Apply changed properties to the defaults
			
			//	Set up local variables based on the properties
			labelSelector = settings.labelSelector,
			inlineClass = settings.classLabelInline,
			inactiveClass = settings.classLabelNormal,
			activeClass = settings.classLabelSelected;

		//	Helper functions to use inside the plugin
		
		//	Apply the active style
		var _activateLabel = function(label) {
			label.removeClass(inactiveClass).addClass(activeClass);
		};
		
		//	Apply the inactive style
		var _deactivateLabel = function(label) {
			label.removeClass(activeClass).addClass(inactiveClass);
		};

		//	Get the value of an input
		var _getValue = function (input) {
			return input.val();
		};

		//	Is the <select> element set to the "null" value?
		var _isNullValue = function (select) {
			var id = $(select).attr('id'),		//	Get the <select> element id to handle special cases
				regex = /travelerType/,			//	Regular expression to match the element id (currently for the Traveler Type menu in Passenger Details)
				regex1 = /month/,					
				value = $(select).val(),		//	The current value of the element
				index = select.selectedIndex;	//	The index of the current selection
				
			if (id.search(regex) != -1) {	//	Is this <select> a special case?
				return false;
			} else if (id.search(regex1) != -1) {
				return (value === '' || value < 0  || value === "U");	//	Account for the many simple variations on what null/unselected means
			}
			else {
				return (value === '' || value < 0 || (value === 0 && index === 0) || value === "U");	//	Account for the many simple variations on what null/unselected means
			}
		};
		
		return this.each(function () {	//	Iterate through the forms passed to the plugin
			$(labelSelector, this).each(function() {	//	Iterate through the labels in the form based on the label selector
				var activeLabel = $(this),								//	Make an internal reference to the label
					activeLabelText = $('span.value', activeLabel),		//	Make an internal reference to the label text
					activeInput = $('input, select', activeLabel),		//	Make an internal reference to the <input> or <select> element within the label
					activeValue = activeInput.val(),					//	Make an internal reference to the current value
					activeIndex = activeInput.attr('selectedIndex');	//	Make an internal reference to the current selectedIndex
					
				activeLabel.addClass(inlineClass);	//	Add the specified class to the label

				if (activeIndex === undefined) {		//	If it's not a <select>, do this stuff
					if (activeValue === '') {		//	If there's no value in the field, show and deactivate the label text 
						activeLabelText.show();
						_deactivateLabel(activeLabel);
					} else {
						activeLabelText.hide();		//	Otherwise, hide the label text so it doesn't overlap the value
					}
					
					//	Bind interactions
					activeInput.focus(function () {		//	onFocus, make it active
						_activateLabel(activeLabel);
					});

					activeInput.blur(function () {		//	onBlur, make it inactive
						_deactivateLabel(activeLabel);
						if ($(this).val() === '') {		//	Hide the label if there is a value
							activeLabelText.show();
						} else if (!$(this).val().match(/\S/)) {	//	If only spaces are entered, clear it out
							$(this).val('');
							activeLabelText.show();
						} else {
							activeLabelText.hide();
						}
					});

					activeInput.keypress(function () {	//	Hide the label text when text is entered
						activeLabelText.hide();
					});

					activeInput.keyup(function () {		//	Show the label text if the input value is null
						if ($(this).val() === '') {
							activeLabelText.show();
						} else {
							activeLabelText.hide();
						}
					});

					activeInput.bind('paste,focus', function(){	//	Detect a paste, then behave accordingly
				        var pasted_value = setTimeout(_getValue($(this)), 100);	//	Timeout to wait for value to populate
						if (pasted_value === '') {
							activeLabelText.show();
						} else {
							activeLabelText.hide();
						}
					});

				} else {	//	If the input is a <select>, do this stuff

					activeLabelText.hide();				// Hide the label text

					if (_isNullValue(activeInput)) {	//	Decide whether the input is set to its default/null value
						_deactivateLabel(activeLabel);
					} else {
						_activateLabel(activeLabel);
					}
					
					//	Bind events to the <select>
					activeInput.bind('mouseenter focus', function (e) {		//	On focus or on mouse over, make it active
						_activateLabel(activeLabel);
					});
					
					activeInput.focus(function () {		//	On focus, disable the mouse over actions because of issues in IE7
						$(this).unbind('mouseleave');
					});

					activeInput.blur(function () {		//	On blur, re-enable the mouse out actions
						$(this).mouseleave(function () {
							if (_isNullValue(this)) {
								_deactivateLabel(activeLabel);
							} else {
								_activateLabel(activeLabel);
							}
						});
					});
					
					activeInput.bind('mouseleave blur', function (e) {	//	On blur or mouseleave, deactivate the <select> if it's value is default/null
						if (_isNullValue(this)) {
							_deactivateLabel(activeLabel);
						} else {
							_activateLabel(activeLabel);
						}
					});
				}
			});
		});
	};
})(jQuery);
